import { OrderOperationType } from 'api/types/entity';
import { DialogVerificationCode } from 'modules/account/orderModule/common/components';

import {
  SignOrderFormType,
  Form,
  SignOrderFormErrors,
} from '../../../forms/signOrderForm';

export interface DialogSignOrderFormProps {
  orderType: OrderOperationType;
  isOpen: boolean;
  formError?: SignOrderFormErrors;
  onClose: () => void;
  onSign: (values: SignOrderFormType) => Promise<void>;
}

export const DialogSignOrderForm = ({
  orderType,
  isOpen,
  formError,
  onClose,
  onSign,
}: DialogSignOrderFormProps) => {
  const handleSubmit = async (values: SignOrderFormType) => {
    await onSign(values);
    onClose();
  };
  return (
    <Form initialErrors={formError} onSubmit={handleSubmit}>
      <DialogVerificationCode<SignOrderFormType>
        codeFieldName="otpCode"
        isOpen={isOpen}
        orderType={orderType}
        onClose={onClose}
      />
    </Form>
  );
};
